// @flow
import React from "react";
import Banner from "../components/generic/banner";
import GetInTouch from "../components/ddos-mitigation/getInTouch";
import { TextSection } from "../components/generic/text";
import CustomersAndAwards from "../components/generic/customersAndAwards";

const content = [
  {
    heading: "Global anycast network",
    background: "bg-dark-two",
    className: "handpickedTeam",
    image: "/security/handpicked.png",
    imagePlacement: "left",
    copy: [
      `Path operates a 12Tbps network capacity deployed over 22 of the biggest internet hubs in the world.
      Once connected to Path network, customers’ subnets are advertised from all network nodes hence the DDoS attacks are filtered and stopped in the scrubbing center that is closer to the source of the attack.`,
    ],
  },
  {
    heading: "Stateful mitigation",
    image: "/security/customer-first.png",
    className: "customerFirst",
    imagePlacement: "right",
    copy: [
      `Our patented stateful mitigation technology is capable of blocking unsolicited or illegitimate traffic by tracking network communications and intelligently determining whether or not a given packet should be permitted based on previously observed activity.`,
    ],
  },
  {
    heading: "Revolutionizing uptime with XDP",
    background: "bg-dark-two",
    className: "costEffective",
    image: "/security/diamond-cost-effective.svg",
    imagePlacement: "left",
    copy: [
      `We utilize powerful analytic tools combined with high-performance eBPF based XDP (eXpress Data Path) programs for line-rate packet filtering, the fastest way to detect and manage unwanted traffic in your network.`,
    ],
  },
];

const DDoSMitigation = () => (
  <main className="security">
    <Banner
      heading="Stateful DDoS Mitigation"
      subheading="Path has deployed one of the largest Layers 3 through 7 mitigation platforms."
      caption={`Advanced XDP technology, patented stateful cloud firewall, and 12 Tbps global
        network capacity for ultimate DDoS defense.`}
    />
    <CustomersAndAwards />
    <TextSection {...content[0]} />
    <TextSection {...content[1]} />
    <TextSection {...content[2]} />
    <GetInTouch />
  </main>
);

export default DDoSMitigation;



// WEBPACK FOOTER //
// ./src/pages/index.js